/* **********************************
 * _includeUI.js
 ********************************** */
function init_includeHtml() {

  // setting.js で定義したHTML文字列を挿入
  // js-pageMenu要素が有れば: ePICOページメニューを挿入
  if ( $('#js-pageMenu').length ) {
    include_html(PAGEMENU_HTML_STRING, 'js-pageMenu');
  }
  // js-pageMenu要素が有れば: ePICOサイトナビを挿入
  if ( $('#js-siteNavi').length ) {
    include_html(SITENAVI_HTML_STRING, 'js-siteNavi');
  }

  // 指定要素に部品HTMLを挿入、RELATIVEPATH文字列を[data-rpath]属性に置換
  function include_html(replaceStr, includeSelector){
    if( !$("#" + includeSelector).length ){
      console.log("ERR: not found element: #" + includeSelector);
      return;
    }
    $("#" + includeSelector).empty();
    var includeElm = document.getElementById(includeSelector);
    includeElm.insertAdjacentHTML('afterbegin', replaceStr);
  }

}

/* **********************************
 * scripts.js
 ********************************** */

// マウスオーバー（'.js-mouseover' 画像ファイル末尾 _on, _off を置換、巻き込み注意）
// eslint-disable-next-line no-unused-vars
function init_mouseover(mouseoverClassName) {
  $(mouseoverClassName).each(function () {
    var src_off = $(this).find('img').attr('src');
    var src_on = src_off.replace('_off', '_on');
    $('<img />').attr('src', src_on);
    $(this).hover(
      function () {
        if (isSP()) {
          $(this).find('img').attr('src', src_off); // SP時はホバー演出しない
        } else {
          $(this).find('img').attr('src', src_on); // PC時のみホバー演出する
        }
      },
      function () {
        $(this).find('img').attr('src', src_off);
      }
    );
  });
}

// スムーススクロール "a.js-pageScroll"
// eslint-disable-next-line no-unused-vars
function init_pageScroll(triggerElm) {
  $(triggerElm + '[href^="#"]').on('click', function () {
    var hrefStr = $(this).attr('href');
    if (!hrefStr || hrefStr === '#') {
      return;
    }

    // SP時はFIXヘッダ高さの値をマイナス
    var heightSpHeader = 0;
    if (isSP() === true) {
      heightSpHeader = $('.l-header__body').outerHeight() * -1;
    }

    var offsetObj = $(hrefStr).offset();
    if (offsetObj && offsetObj.top) {
      $('html,body').animate(
        { scrollTop: offsetObj.top + heightSpHeader },
        'slow',
        'swing'
      );
    } else {
      $('html,body').animate({ scrollTop: heightSpHeader }, 'slow', 'swing');
    }
    return false;
  });
}

// ページトップへ戻るボタンのアニメーション
// eslint-disable-next-line no-unused-vars
function init_returnTop(scrollFadeClass) {
  var $pageTop = $(scrollFadeClass);
  $pageTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 300) {
      $pageTop.fadeIn();
    } else {
      $pageTop.fadeOut();
    }
  });
}

// ページ幅でSP判定
// eslint-disable-next-line no-unused-vars
function isSP() {
  return window.matchMedia('(max-width: 768px)').matches;
}

// tabel要素のレスポンシブ対応
(function ($) {
  $.fn.responsiveTable = function (config) {
    var defaults = {
      // captionText: 'スクロールしてご確認ください。',
      size: 1,
    };

    var options = $.extend(defaults, config);
    return this.each(function () {
      var $this = $(this);

      // is-noStyleクラス: レスポンシブ処理を行わない
      if ($this.hasClass('is-noStyle')) {
        return true; // 後続のtableも処理したいので continue
      }

      var $cells = $this.find('tr:first > *');
      var table_size = $this.find('tr:first > *').length;

      for (var i = 0; i < $cells.length; i++) {
        var $cell = $cells.eq(i);
        var colspan = $cell.attr('colspan');

        if (colspan) {
          table_size = table_size + (colspan - 1);
        }
      }

      if (table_size > options.size || $this.is('.sp-scrollTable')) {
        $this.wrap('<div class="c-tableWrapper"></div>');

        var $wrapper = $this.closest('.c-tableWrapper');
        $wrapper.before(
          '<p class="c-tableCaption"><span>※この表は横にスクロールできます</span></p>'
        );
      }
    });
  };
})(jQuery);

// IE判定（HTML要素に isIEクラスを付与）
// eslint-disable-next-line no-unused-vars
function init_class_isIE() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var ieFlag =
    userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1;
  if (ieFlag) {
    $('html').addClass('isIE');
  }
  return ieFlag;
}

// Android判定（HTML要素に isAndroidクラスを付与）
// eslint-disable-next-line no-unused-vars
function init_class_isAndroid() {
  var userAgent = window.navigator.userAgent.toLowerCase();
  var androidFlag = userAgent.indexOf('android') > 0;
  if (androidFlag) {
    $('html').addClass('isAndroid');
  }
  return androidFlag;
}

// アコーディオン
// eslint-disable-next-line no-unused-vars
function init_accordion() {
  // 初期化処理
  $('.js-accordion').off('click', '.js-accordion__head');
  $('.js-accordion__body').hide();

  // 初期化処理: is-open付与のアコーディオンを開く
  $('.js-accordion.is-open .js-accordion__body').show();

  // eslint-disable-next-line no-unused-vars
  $('.js-accordion').on('click', '.js-accordion__head', function (e) {
    var $accordion = $(this).closest('.js-accordion');
    if (!$accordion.hasClass('is-open')) {
      $accordion
        .addClass('is-open')
        .children('.js-accordion__body')
        .stop()
        .slideDown();
    } else {
      $accordion
        .children('.js-accordion__body')
        .stop()
        .slideUp(function () {
          $accordion.removeClass('is-open');
        });
    }
    return false;
  });

  // //アコーディオンの展開
  // var getURL = location.href;
  // if ( getURL.indexOf('?q=') === -1) {
  //   var URLID = getURL.split('#');
  //   if(URLID[1]) {
  //     var $getID = '#' + URLID[1];
  //     if($($getID).is('.accordion')) {
  //       $($getID).addClass('is-open');
  //       $($getID).children('.js-accordion__body').show();
  //     }
  //   }
  // }
}

/* **********************************
 * _commonSlider.js
 ********************************** */
function init_commonSlider(sliderSelector) {
  const elms = $(sliderSelector).get();
  for ( let i = 0; i < elms.length; i++ ) {

    // data-slider-num属性で表示数を指定（省略時は5毎表示）
    let slierColmn = $(elms[i]).attr('data-slider-num');
    slierColmn = slierColmn ? slierColmn : 5;

    // data-slider-num属性で表示数を指定（省略時は5毎表示）
    let slierColmnSp = $(elms[i]).attr('data-slider-num-sp');
    slierColmnSp = slierColmnSp ? slierColmnSp : 2;

    // data-slider-interval属性でスライダー待機時間を指定（省略時は5秒表示）
    let intervalSec = $(elms[i]).attr('data-slider-interval');
    intervalSec = intervalSec ? intervalSec : 5000;

    // data-slider-speed属性でスライダー待機時間を指定（省略時は1秒表示）
    let speedSec = $(elms[i]).attr('data-slider-speed');
    speedSec = speedSec ? speedSec : 1000;

    // data-slider-haspagenation属性でページネーションON/OFF（省略時はOFF）
    let hasPagenation = $(elms[i]).attr('data-slider-haspagenation');
    hasPagenation = hasPagenation ? hasPagenation : false;

    // Splide 初期化
    const cSplide = new Splide(elms[i], {
      type: 'loop',
      autoplay: true,
      interval: intervalSec,
      perPage: slierColmn,
      rewind: true,
      speed:  speedSec,
      pagination: hasPagenation,
      focus: 'center',
      pauseOnHover: false,
      pauseOnFocus: false,
      breakpoints: {
        768: {
          perPage: slierColmnSp
        }
      }
    }).mount();
    const { Autoplay } = cSplide.Components;

    // 自動再生の停止ボタン
    $(elms[i]).find('.js-splide-btnPause').on("click", function(){
       // pauseOnFocus:false にしないとフォーカス時は常にtureとなることに留意
      if( Autoplay.isPaused() === false ){ 
        Autoplay.pause();
      }else{
        Autoplay.play();
      }
    });

  }
}



/* **********************************
_dialogModal.js

  init_dialogModal('js-dialogmodal', 'data-dialogmodal');

  <dialog id="modalA">
    SHOW MODAL
    <button type="button" data-dialogmodal-close>✖閉じる</button>
  </dialog>
  <button type="button" data-dialogmodal-open="modalA">●開く</button>
 
 ********************************** */
function init_dialogModal (modalCls, propName) {
  // モーダル用の属性名を取得
  const openProp = `${propName}-open`; // [data-dialogmodal-open]
  const closeProp = `${propName}-close`; // [data-dialogmodal-close]

  // モーダルOPEN処理
  const openModal = (ev) => {
    const elm = ev.target.closest(`[${openProp}]`);
    const openModalId = elm.attributes[openProp].value;
    document.getElementById(openModalId).showModal();
  };

  // モーダルCLOSE処理
  const closeModal = (ev) => {
    const elm = ev.target.closest(`.${modalCls}`); // 閉じるボタンの親を遡って
    const closeModalId = elm.attributes['id'].value; // modalClsクラスのid要素を参照
    document.getElementById(closeModalId).close();
  };

  // dialog::backdrop要素クリック時に閉じる処理
  const backdropClose = (ev) => {
    if (ev.target.nodeName === 'DIALOG') {
      ev.target.close();
    }
  };

  // 初期化処理: イベントリスナを付与
  const initModal = () => {
    // ページ内の[data-dialogmodal-open]属性を持つ要素
    const openModalList = document.querySelectorAll(`[${openProp}]`);
    openModalList.forEach((elm, idx) => {
      elm.removeEventListener('click', openModal, false);
      elm.addEventListener('click', openModal, false);
    });

    // ページ内の[data-dialogmodal-close]属性を持つ要素
    const closeModalList = document.querySelectorAll(`[${closeProp}]`);
    closeModalList.forEach((elm, idx) => {
      elm.removeEventListener('click', closeModal, false);
      elm.addEventListener('click', closeModal, false);
    });

    // dialog::backdrop要素クリック時: 現在開いてるダイアログを閉じる
    const dialogList = document.querySelectorAll(`dialog`);
    dialogList.forEach((elm, idx) => {
      elm.removeEventListener('click', backdropClose, false);
      elm.addEventListener('click', backdropClose, false);
    });
  };

  // DOM構築を待ってから初期化を実行
  setTimeout(() => {
    initModal();
  }, 100);
};

function init_ytShortSlider() {

  // js-pageMenu要素が無ければスキップ
  if (!$('.js-ytShortSlider').length) {
    return;
  }

  new Splide( '.js-ytShortSlider', {
    type: 'loop',
    lazyLoad: 'nearby',
    preloadPages: 1
  }).mount();

}
/* **********************************
_morphAnimation.js
 ********************************** */
const MorphAnimation = (configs, breakpoints, resizeCallback) => {
  let pathElm;
  let defaultSpeed = 1000;
  let defaultEasing = mina.easeinout;
  let svg;
  let paths = [];
  let isAnimating = true;
  let pausedPath = '';
  let currentPathIndex = 0;
  let currentBreakpoint = '';
  let resizeObserver = null;

  // バウンディングボックスを下固定
  const positionBottom = () => {
    const pathBox = pathElm.getBBox();
    const svgHeight = svg.node.clientHeight;
    const translateY = svgHeight - pathBox.height;
    pathElm.attr({ transform: `translate(0, ${translateY})` });
  };

  // バウンディングボックスを上固定
  const positionTop = () => {
    const pathBox = pathElm.getBBox();
    pathElm.attr({ transform: `translate(0, 0)` });
  };

  // バウンディングボックスを左固定
  const positionLeft = () => {
    const pathBox = pathElm.getBBox();
    pathElm.attr({ transform: `translate(0, ${pathBox.y})` });
  };

  // バウンディングボックスを右固定
  const positionRight = () => {
    const pathBox = pathElm.getBBox();
    const svgWidth = svg.node.clientWidth;
    const translateX = svgWidth - pathBox.width;
    pathElm.attr({ transform: `translate(${translateX}, ${pathBox.y})` });
  };

  // アニメーションの座標調整
  const adjust = () => {
    if (isAnimating) {
      window.requestAnimationFrame(() => {
        positionBottom();
        adjust();
      });
    }
  };

  // 次のモーフィングパスを再生
  const morphToNextPath = () => {
    if (!isAnimating) return;
    currentPathIndex = (currentPathIndex + 1) % paths.length;
    const { d, speed, easing } = paths[currentPathIndex];
    pathElm.stop().animate({ d }, speed || defaultSpeed, easing || defaultEasing, morphToNextPath);
  };

  // アニメーション再生
  const start = () => {
    if (!isAnimating) return;
    const { d } = paths[currentPathIndex];
    pathElm.attr({ d: pausedPath || d });
    pausedPath = '';
    morphToNextPath();
    dprint("morph: start")
  };

  // 再生・一時停止をトグル
  const toggle = () => {
    isAnimating = !isAnimating;
    return isAnimating;
  };

  // アニメーション一時停止
  const pause = () => {
    pausedPath = pathElm.attr('d');
    pathElm.stop();
    dprint("morph: pause")
  };

  // アニメーション初期化
  const init = (newConfig) => {
    pathElm = newConfig.pathElm;
    svg = newConfig.svg;
    paths = newConfig.paths;
    defaultSpeed = newConfig.defaultSpeed || defaultSpeed;
    defaultEasing = newConfig.defaultEasing || defaultEasing;

    // SVG要素のwidth、height、viewBox属性を設定
    if (newConfig.width) {
      svg.attr('width', newConfig.width);
    }
    if (newConfig.height) {
      svg.attr('height', newConfig.height);
    }
    if (newConfig.viewBox) {
      svg.attr('viewBox', newConfig.viewBox);
    }

    // ページの表示状態変更イベントを監視（サポートされている場合のみ）
    if (typeof document.hidden !== 'undefined') {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    }

    // リサイズオブザーバーの設定（SVGバウンディングボックスを監視）
    setupResizeObserver();

    // ページ離脱時のイベントリスナーを登録
    window.addEventListener('beforeunload', cleanup);

    // IntersectionObserverで起動させるのでコメントアウト
    // adjust();
    // start();
  };

  // 現在のブレイクポイントを取得
  const getCurrentBreakpoint = () => {
    for (const [breakpoint, mediaQuery] of Object.entries(breakpoints)) {
      if (window.matchMedia(mediaQuery).matches) {
        return breakpoint;
      }
    }
    return 'pc';
  };

  // ブレイクポイント変更時の処理
  const handleBreakpointChange = () => {
    const newBreakpoint = getCurrentBreakpoint();
    if (newBreakpoint !== currentBreakpoint) {
      currentBreakpoint = newBreakpoint;
      dprint(`Current breakpoint: [${currentBreakpoint}] ${breakpoints[currentBreakpoint]}`);
      init(configs[currentBreakpoint]);
    }
  };

  // resizeオブザーバー: 生成
  const setupResizeObserver = () => {
    resizeObserver = new ResizeObserver((entries) => {
      handleBreakpointChange();
      resizeCallback();
    });
    resizeObserver.observe(document.body);
  };

  // resizeオブザーバー: 消去
  const cleanupResizeObserver = () => {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  };

  // ブラウザタブ切り替え時（ページ全体非表示時）
  const handleVisibilityChange = () => {
    if (document.hidden) {
      // ページ非表示時: アニメーションを一時停止
      dprint(`pause()`);
      pause();
    } else {
      // ページ再表示時:アニメーションを再開
      dprint(`start()`);
      start();
    }
  };

  // クリーンアップ関数
  const cleanup = () => {
    cleanupResizeObserver();
    // visibilitychangeイベントのリスナを削除
    if (typeof document.hidden !== 'undefined') {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    }
    // beforeunloadイベントのリスナを削除
    window.removeEventListener('beforeunload', cleanup);
  };

  // デバック出力
  const dprint = (msg) => {
    if (configs.debug !== true) return;
    console.log(msg);
  };

  // 初期化
  currentBreakpoint = getCurrentBreakpoint();
  init(configs[currentBreakpoint]);
  dprint(`Init breakpoint: [${currentBreakpoint}] ${breakpoints[currentBreakpoint]}`);

  // 公開メソッド
  return {
    init,
    start,
    adjust,
    toggle,
    pause,
    cleanup,
  };
};

/* **********************************
 * _topKvSlider.js
 ********************************** */
function init_topKvSlider(sliderSelector) {
  if (!$(sliderSelector).length) {
    return;
  }
  
  const elms = $(sliderSelector).get(0);

  // data-slider-interval属性でスライダー待機時間を指定（省略時は5秒表示）
  let intervalSec = $(elms).attr('data-slider-interval');
  intervalSec = intervalSec ? intervalSec : 5000;

  // data-slider-speed属性でスライダー待機時間を指定（省略時は1秒表示）
  let speedSec = $(elms).attr('data-slider-speed');
  speedSec = speedSec ? speedSec : 1000;

  // Splide 初期化
  const topKvSplide = new Splide(elms, {
    type: 'loop',
    autoplay: true,
    interval: intervalSec,
    perPage: 1,
    rewind: true,
    speed:  speedSec,
    pagination: false,
    arrows: false,
    focus: 'center',
    pauseOnHover: false,
    pauseOnFocus: false,
    breakpoints: {
      768: {
        perPage: 1
      }
    }
  }).mount();
  const { Autoplay } = topKvSplide.Components;

  // 前ボタン
  $('.js-toppageKV-prev').on('click', function(){
    topKvSplide.go('+1');
  });

  // 次ボタン
  $('.js-toppageKV-next').on('click', function(){
    topKvSplide.go('-1');
  });
  
}



/* **********************************
  _topKvMorph.js
 ********************************** */
function init_topKvMorph() {

  // ブレイクポイントの定義
  const breakpoints = {
    sp: '(max-width: 768px)',
    pc: '(min-width: 769px)',
  };
 
  // リサイズ時の微調整
  const resizeTransform = () => {
    if ( window.matchMedia('(max-width: 768px)').matches ) {
      const pageWidth = $(window).width();
      const scalePop = 1.61 * pageWidth / 1920;
      $('.js-topKvMorph-scale').css('transform', 'scale(' + scalePop + ')');
    } else {
      $('.js-topKvMorph-scale').css('transform', 'scale(1.24)');
    }
  };
 
      
  
 
  // ボタンイベント
  // ---------------------------------------
  const ButtonEventHandler = (morph) => {
    // const toggleButton = document.getElementById('toggleButton');
    // toggleButton.textContent = 'Pause';
    // toggleButton.addEventListener('click', () => {
    //   const isAnimating = morph.toggle();
    //   toggleButton.textContent = isAnimating ? 'Pause' : 'Play';
    //   if (isAnimating) {
    //     morph.adjust();
    //     morph.start();
    //   } else {
    //     morph.pause();
    //   }
    // });
  };

  // 波アニメ（#waveSvg）がブラウザ表示から外れたら pause、再表示時は start
  // ---------------------------------------
  const IntersectionHandler = (morph) => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          //console.log("entry.isIntersecting: " + entry.isIntersecting);
          morph.adjust();
          morph.start();
        } else {
          //console.log("entry.isIntersecting: " + entry.isIntersecting);
          morph.pause();
        }
      });
    }, options);

    const target = document.querySelector('#waveSvg');
    observer.observe(target);
  };
 
  // アニメーション起動
  // ---------------------------------------
  if (!$('#waveSvg').length) {
    return;
  }
  const anim = MorphAnimation(TOPPAGE_KV_MORPH_CONFIGS, breakpoints, resizeTransform);
  ButtonEventHandler(anim);
  IntersectionHandler(anim);

 }
/* **********************************
 * _topUsevoiceSlider.js
 ********************************** */
function init_topUsevoiceSlider(sliderSelector) {
  if (!$(sliderSelector).length) {
    return;
  }

  const elms = $(sliderSelector).get(0);

  // data-slider-interval属性でスライダー待機時間を指定（省略時は5秒表示）
  let intervalSec = $(elms).attr('data-slider-interval');
  intervalSec = intervalSec ? intervalSec : 5000;

  // data-slider-speed属性でスライダー待機時間を指定（省略時は1秒表示）
  let speedSec = $(elms).attr('data-slider-speed');
  speedSec = speedSec ? speedSec : 1000;

  // Splide 初期化
  const topUvSplide = new Splide(elms, {
    type: 'loop',
    autoplay: false,
    interval: intervalSec,
    perPage: 1,
    rewind: true,
    speed:  speedSec,
    pagination: true,
    arrows: true,
    focus: 'center',
    pauseOnHover: false,
    pauseOnFocus: false,
    breakpoints: {
      768: {
        perPage: 1
      }
    }
  });
  const { Autoplay } = topUvSplide.Components;

  // SP時：操作UIの座標調整処理
  function uiPosFix(){
    const slideElm = topUvSplide.Components.Slides.getAt(topUvSplide.index).slide;
    const slideH = $(slideElm).find('.p-toppageTouch__sheet').height();
    const totalH = $('.p-toppageTouch__uservoice__slider').height();
    const pagenationBtm = totalH - slideH + 10;
    const buttonBtm = totalH - slideH - 50;
    $('.js-topUservoiceSlider-pagenation').css('bottom', pagenationBtm + 'px');
    $('.js-topUservoiceSlider-button').css('bottom', buttonBtm + 'px');
  }

  // Splideセットアップ時: 操作UI(SP時)を座標調整処理
  topUvSplide.on('mounted', function () {
    uiPosFix();
    $('.js-topUservoiceSlider-pagenation').fadeIn(200);
    $('.js-topUservoiceSlider-button').fadeIn(200);
  });

  // Splideリサイズ時: 操作UI(SP時)を座標調整処理
  topUvSplide.on('resized', function () {
    uiPosFix();
    $('.js-topUservoiceSlider-pagenation').fadeIn(200);
    $('.js-topUservoiceSlider-button').fadeIn(200);
  });

  // Splideスライド移動前: 背景装飾(PC時)、操作UI(SP時)をフェードアウト
  topUvSplide.on('move', function () {
    if( isSP() ){
      $('.js-topUservoiceSlider-pagenation').fadeOut(100);
      $('.js-topUservoiceSlider-button').fadeOut(100);

    }else{
      $('.js-topUservoiceSlider-backCircle').fadeOut(100);
    }
  });

  // Splideスライド移動後: 背景装飾(PC時)、操作UI(SP時)をフェードイン、座標調整処理
  topUvSplide.on('moved', function () {
    if( isSP() ){
      $('.js-topUservoiceSlider-pagenation').fadeIn(200);
      $('.js-topUservoiceSlider-button').fadeIn(200);
      uiPosFix();
    }else{
      $('.js-topUservoiceSlider-backCircle').fadeIn(400);
    }
  });

  // イベント登録後に mount
  topUvSplide.mount();
  
}



/* **********************************
 * shopAreaMap.js
 ********************************** */
function init_shopAreaMap(){

  // SVGマップ制御用クラス
  var selJpMap = '.js-shopAreaMap';

  // ガード節
  if( !$(selJpMap).length || $(selJpMap).length === 0){
    return;
  }

  // data-svgpath属性で指定したSVGファイルをロード、DOMに配置
  var selTarget = selJpMap + '[data-svgpath]';
  $(selTarget).each( function(idx, el) {
    var svgpath = $(el).attr('data-svgpath') + ' svg';
    $(el).load( svgpath, function(){
      setup_svg( el ); // 読み込み後の初期化処理
    });
  });

  // ----------------------------------------------------------
  // カスタムイベント: PINクリック ⇒アンカースクロール
  $(window).on('onClickJapanMapPIN', function(e, xhref){
    var parkNo = parseInt( xhref.split("#AREA")[1], 10 );
    var hrefStr = "#AREA_ANCHOR" + parkNo;
    console.log(hrefStr);

    var offsetObj = $(hrefStr).offset();
    if(offsetObj && offsetObj.top){
      // CSSの scroll-behavior を一時的にOFF
      $("html,body").css('scroll-behavior', 'auto');
      $("html,body").stop().animate({ scrollTop: offsetObj.top }, 600, 'swing', function(){
        $("html,body").css('scroll-behavior', 'smooth'); // 演出後に戻す
      });
    }else{
      $("html,body").stop().animate({ scrollTop: 0 }, 600);
    }
    return false;
  });


  // ----------------------------------------------------------
  // SVGファイルの再フォーマット
  function setup_svg( cSvgBox ){
    var cSvg = $(cSvgBox).children('svg');
    var cSvgH = $(cSvg).attr('height');
    var cSvgW = $(cSvg).attr('width');

    // SVG要素の拡縮hack
    $(cSvgBox).attr('style', 'padding-bottom: calc( 100% * ( ' +cSvgH+ ' / ' + cSvgW +' ))');

    // SVG宣言 xmlns:xlink属性 aria-labelledby属性 preserveAspectRatio属性
    $(cSvg).attr('xmlns:xlink', 'http://www.w3.org/1999/xlink');
    $(cSvg).attr('aria-labelledby', 'maptitle');
    $(cSvg).attr('preserveAspectRatio', 'xMidYMin meet');

    // 各PINに対してa要素でラップ
    $(cSvg).find('g[id^="AREA"]').each( function(gidx, gel){
      var cgid = $(gel).attr('id');
      wrapSvgLink(gel, '#'+ cgid);
    })

    // Hack: ツールチップにaria-labelledbyが反映されないのでSVG要素のDOMを強制的に再描画
    $(cSvg)[0].innerHTML += "";

    // イベント: SVG上のアンカーリンク クリック時: PINクリックイベントを発火
    $(cSvg).find('a').on('click', function (e) {
      var xhref = String( $(this).attr("xlink:href") );
      if( xhref.charAt(0) === "#" ){
        $(window).trigger("onClickJapanMapPIN", xhref);
      }
    });

    // SVG要素をリンクでラップ（<a xlink:href=""）
    //     jQueryだと動的にSVGに要素を追加できないので PureJS で書く
    function wrapSvgLink(elem, url) {
      var a = document.createElementNS(elem.namespaceURI, "a");
      a.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", url);
      elem.parentNode.insertBefore(a, elem);
      a.appendChild(elem);
    }
  }

}


/* **********************************
  _tabBox.js
 ********************************** */
function init_tabBox(tabSelector) {

  // ガード節
  if (!$(tabSelector).length) {
    return;
  }

  const headSelector = tabSelector + '__head';
  const bodySelector = tabSelector + '__body';
  const contentselector = tabSelector + '__contents';

  // カレントのパネル表示
  function viewCurrentPanel(){
    const currentContents = $(tabSelector).find('.is-current').find(contentselector).html();
    $(bodySelector).hide();
    $(bodySelector).html(currentContents);
    $(bodySelector).fadeIn(400);
  }

  // タブボタンクリック
  $(headSelector).on('click', 'button', function (ev) {
    // カレント表示
    $(headSelector).children('li').removeClass('is-current');
    $(this).closest('li').addClass('is-current');
    viewCurrentPanel();
  });

  // 初期表示
  viewCurrentPanel();

}
/* **********************************
 * scripts.js (Entry Point)
 ********************************** */
$(function(){

  // setting.js のJS変数に格納されたHTMLタグを挿入
  init_includeHtml();

  // スムーススクロール: 初期化 → scroll-behavior:smooth を使うので不要
  // init_pageScroll('.js-pageScroll');

  // アコーディオンリスト: 初期化
  init_accordion();

  // 汎用スライダー: 初期化
  init_commonSlider('.js-splideSlider');

  // YTショート用のスライダー：初期化
  init_ytShortSlider();

  // Dialogモーダル
  init_dialogModal('js-dialogmodal', 'data-dialogmodal');

  // トップページKV
  init_topKvSlider('.js-topKvSlider');
  init_topKvMorph();
  init_topUsevoiceSlider('.js-topUservoiceSlider');

  // 店舗MAPアンカースクロール
  init_shopAreaMap();

  // タブ切替ボックス
  init_tabBox('.js-tabBox');
});
